import React from 'react'

import ReactLoading from 'react-loading'

import styles from './styles.module.css'
import useColors from 'utils/Colors'

const LoadingOverlay = () => {
  const Colors = useColors()

  return (
    <div className={styles.container}>
      <ReactLoading
        type={'spin'}
        color={Colors.Primary[5]}
        width={75}
        height={75}
        className={styles.spinner}
      />
    </div>
  )
}

export default LoadingOverlay
